import * as actionTypes from './actionTypes';
import * as baseAction from './baseAction';

export const masterBlasterStart = (accessToken, data) => baseAction.actionStart(actionTypes.MASTERBLASTER_START, accessToken, data);
export const masterBlasterSuccess = (data) => baseAction.actionSuccess(actionTypes.MASTERBLASTER_SUCCESS, data);
export const masterBlasterFail = (error) => baseAction.actionFail(actionTypes.MASTERBLASTER_FAIL, error);

export const masterBlasterQueue = (options) => {
    return (dispatch, getState) => {
        let { file, ...rest } = options.data;

        baseAction.actionExecute(dispatch, getState, {
            type: 'create',
            multiPart: true,
            files: (file) ? [file] : null,
            url: `/MasterBlaster`,
            payload: rest,
            startFn: (accessToken) => dispatch(masterBlasterStart(accessToken, { lastScope: 'queue' })),
            successFn: (response) => dispatch(masterBlasterSuccess({ queue: response.data, isNew: false })),
            failFn: (error) => dispatch(masterBlasterFail(error))
        });    
    };
};
